module.exports = __webpack_public_path__ + "static/media/img1.51a60c02.png";